module.exports = __webpack_public_path__ + "img/menucn_5_8.45643c89.svg";